import { QueryHookOptions, useQuery, useSubscription } from '@apollo/client';

import query from './unreadNotificationsCount.graphql';
import notificationsQuery from './notifications.graphql';
import notificationReceivedSubscription from './notificationReceived.graphql';

const REFETCH_QUERIES = [query, notificationsQuery];

export default function useUnreadNotificationsCount(
  options?: QueryHookOptions<
    UnreadNotificationsCountQuery,
    UnreadNotificationsCountQueryVariables
  >,
) {
  const result = useQuery<
    UnreadNotificationsCountQuery,
    UnreadNotificationsCountQueryVariables
  >(query, options);

  useSubscription<NotificationReceivedSubscription>(
    notificationReceivedSubscription,
    {
      onData: ({ client }) => {
        client.refetchQueries({ include: REFETCH_QUERIES });
      },
    },
  );

  return result;
}
